import classnames from 'classnames';

interface ProfileImageProps {
  large?: boolean;
  photoUrl?: string | null;
  userName: string;
}

const ProfileImage = ({ large = false, photoUrl = null, userName }: ProfileImageProps) => {
  const initials = userName.split(' ');
  const firstInitial = initials[0][0];
  const lastInitial = initials.length > 1 ? initials.pop()![0] : '';

  return photoUrl ? (
    <div
      aria-label={`${userName}'s profile image`}
      className={classnames({
        'profile-photo-preview': large,
        'profile-photo': !large,
      })}
      data-testid="users-profile-image"
      role="img"
      style={{ backgroundImage: `url(${photoUrl})` }}
    />
  ) : (
    <div
      aria-label={`${userName}'s profile image`}
      className={classnames('bg-primary fw-bold rounded-circle text-white', {
        'profile-photo-preview': large,
        'profile-photo': !large,
      })}
      data-testid="users-profile-image"
      role="img"
    >
      {`${firstInitial}${lastInitial}`}
    </div>
  );
};

export default ProfileImage;
